export default "__VITE_ASSET__B1pLQQe7__"